var _path, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpecialPlan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#BEFAF0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22418_1751",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22418_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1871 31.7499L28.6558 23.9999H23.6558L24.5621 16.9061L18.7808 25.2499H23.1246L22.1871 31.7499ZM20.9708 27.1248H17.1679C16.748 27.1248 16.4403 26.9389 16.2448 26.5671C16.0493 26.1954 16.0734 25.8372 16.317 25.4926L24.5068 13.6778C24.675 13.4423 24.8898 13.2812 25.151 13.1947C25.4122 13.1081 25.6838 13.1154 25.9659 13.2163C26.2479 13.3173 26.4543 13.49 26.5849 13.7343C26.7155 13.9787 26.7639 14.2419 26.7303 14.524L25.7904 22.1249H30.4538C30.8993 22.1249 31.2135 22.3244 31.3961 22.7235C31.5788 23.1225 31.5251 23.4943 31.2351 23.8388L22.1799 34.6849C21.9988 34.8996 21.7776 35.0386 21.5164 35.1019C21.2552 35.1652 21.0004 35.14 20.752 35.0262C20.5036 34.9124 20.3109 34.7386 20.1739 34.5046C20.0369 34.2706 19.9852 34.0126 20.0189 33.7305L20.9708 27.1248Z",
    fill: "#08A68C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialPlan);
export default __webpack_public_path__ + "static/media/special-plan.55fe6962cc4e4f06090fe794fb8c7f28.svg";
export { ForwardRef as ReactComponent };